import { useLayoutEffect, useRef, useState } from "react";
import ChecklistCompactPageHeader from "./ChecklistCompactPageHeader";
import ChecklistGapsBar from "./ChecklistGapsBar";

/**
 * Mobile/tablet checklist chrome: pins compact header + gaps under the global
 * topbar while items scroll.
 *
 * Desktop (xl+): hidden — pages render gaps under the in-page checklist header
 * instead, so the bar does not sit above breadcrumbs / flush against the topbar.
 */
export default function ChecklistStickyFillChrome({
  title,
  subtitle,
  backTo,
  progressLabel,
  statusLabel,
  items,
}) {
  const barRef = useRef(null);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    const el = barRef.current;
    if (!el) return undefined;

    const update = () => setHeight(el.getBoundingClientRect().height);
    update();

    if (typeof ResizeObserver === "undefined") return undefined;
    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => observer.disconnect();
  }, [items, title, progressLabel, statusLabel]);

  return (
    <>
      <div
        ref={barRef}
        className="fixed z-40 border-b border-[#e5e8ec] bg-white/95 shadow-[0_4px_14px_rgba(20,23,28,0.08)] backdrop-blur-sm supports-[backdrop-filter]:bg-white/92 xl:hidden"
        style={{
          // Layout-fixed under the dashboard topbar only (vv offset is not additive).
          top: "var(--dashboard-topbar-height, 4rem)",
          left: "var(--dashboard-sidebar-width, 0px)",
          right: 0,
        }}
      >
        <ChecklistCompactPageHeader
          title={title}
          subtitle={subtitle}
          backTo={backTo}
          progressLabel={progressLabel}
          statusLabel={statusLabel}
        />
        <div className="px-2 pb-1.5 pt-1 sm:px-3">
          <ChecklistGapsBar items={items} position="static" />
        </div>
      </div>
      <div
        className="flex-shrink-0 xl:hidden"
        style={{ height }}
        aria-hidden
      />
    </>
  );
}
